import { Box } from '@/shared/ui';

import { parseVersionHistoryText } from '@/features/factsheet/lib/versionHistory';
import type { FactsheetDetails } from '@/features/factsheet/types';

import TextLinesDisplay from '../TextLinesDisplay';

interface CriteriaTabProps {
  factsheet: FactsheetDetails;
}

const CriteriaTab = ({ factsheet }: CriteriaTabProps) => {
  const criteriaLines = parseVersionHistoryText(factsheet, 'criteriaForInclusion');

  return (
    <Box>
      <TextLinesDisplay lines={criteriaLines} />
    </Box>
  );
};

export default CriteriaTab;
